module.exports = __webpack_public_path__ + "static/media/mechanisms_maker1.d2d80b07.png";